var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.status
        ? [
            _vm.status.type == "icon"
              ? [
                  _c(
                    "vs-tooltip",
                    {
                      staticStyle: { float: "left", margin: "0px 5px 0 0" },
                      attrs: { text: _vm.status.text, position: "top" }
                    },
                    [
                      _c("i", {
                        class: "fas fa-circle" + " text-" + _vm.status.color,
                        staticStyle: {
                          "font-size": "9px",
                          position: "relative",
                          top: "-2px"
                        }
                      })
                    ]
                  )
                ]
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.$slots.default
        ? _vm._t("default")
        : [
            !_vm.checkAuth({ app_id: _vm.to_appid }) || _vm.disabled
              ? _c("span", { class: [{ opacity30: _vm.disabled }] }, [
                  _vm._v("\n      " + _vm._s(_vm.text) + "\n    ")
                ])
              : _vm.checkAuth({ app_id: _vm.to_appid })
              ? _c("router-link", { attrs: { to: _vm.to } }, [
                  _vm._v("\n      " + _vm._s(_vm.text) + "\n    ")
                ])
              : _vm._e()
          ],
      _vm._v(" "),
      _vm.status
        ? [
            _vm.status.type == "message"
              ? [
                  _c(
                    "span",
                    {
                      class: "badge link-status " + " badge-" + _vm.status.color
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.status.text) + "\n      "
                      )
                    ]
                  )
                ]
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41739bd0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41739bd0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom/Link.vue
// module id = null
// module chunks = 